import {
  locationChangePersist,
  storeDefault,
  storeRequest,
  ListStoreDefault,
  ListRequestHandler,
  ListFilterHandler,
  ListSuccessHandler,
  setPartnershipMetadata,
} from 'js/helpers/reducers';

import {
  FETCH_PARTNERSHIP_METADATA,
  FETCHED_PARTNERSHIP_METADATA,
  FETCH_PARTNERSHIP_CONTENT,
  FETCHED_PARTNERSHIP_CONTENT,
  SET_PARTNERSHIP_CONTENT_FILTER,
} from 'components/Pages/Entity/actions';

const defaultState = {
  partnershipContentList: ListStoreDefault({
    pageNum: 1,
    pageSize: 40,
    start_date: '',
    end_date: '',
    keyword_tags: [],
    categories: [],
    brand_ids: [],
    publisher_ids: [],
    searchQuery: '',
    content_type: 'paid',
    sort_by: 'publish_date',
    sort_order: 'desc',
  }),
  metadata: storeDefault({}),
  partner: storeDefault({}),
};

const PartnershipProfileReducer = (state = defaultState, action) => {
  switch (action.type) {
    /* TODO: may not need this: */
    case '@@router/LOCATION_CHANGE':
      return locationChangePersist(state, action, defaultState, {
        sections: ['metadata', 'partner'],
        pathToMatch: `/blueprint/${state.metadata.data.type}/${state.metadata.data.public_id}/${state.partner.data.type}/${state.partner.data.public_id}`,
      });
    case FETCH_PARTNERSHIP_METADATA:
      return Object.assign({}, state, { metadata: storeRequest({}) });
    case FETCHED_PARTNERSHIP_METADATA:
      return setPartnershipMetadata(state, action);
    case FETCH_PARTNERSHIP_CONTENT:
      return ListRequestHandler(state, action, 'partnershipContentList');
    case FETCHED_PARTNERSHIP_CONTENT:
      return ListSuccessHandler(state, action, 'partnershipContentList');
    case SET_PARTNERSHIP_CONTENT_FILTER:
      return ListFilterHandler(state, action, 'partnershipContentList');
    default:
      return Object.assign({}, state);
  }
};

export default PartnershipProfileReducer;
